import cls from "./customInnerPage.module.scss";
import React, {FC} from "react";
import {ISizeChart} from "../../../types/homePageTypes";
import {domainUrl} from "../../../helper";

interface IProps {
    sizeChart: ISizeChart,
    dbName: string,
    domain: string
}

const SizeChartContent: FC<IProps> = ({ sizeChart, dbName, domain }) => {
    let infoChart: Record<string, string>[] = [];

    try {
        const parsed = JSON.parse(sizeChart?.size_chart || "[]");
        if (Array.isArray(parsed)) infoChart = parsed;
    } catch (e) {
        console.error("Invalid size_chart JSON:", e);
    }

    const [headerInfo, ...bodyInfo] = infoChart;
    return (
        <div>
            <div className={cls.main_popup_img_wrapper}>
                <img className={cls.main_popup_img} src={domainUrl(`${dbName}/storage/${domain}/${sizeChart?.image_path}`)} alt={`${sizeChart?.template_name} Image`}/>
            </div>
            <table className={cls.chart_main}>
                <thead>
                    <tr>
                        {Object.values(headerInfo).map((item: string, index) => {
                            return <th key={index}>{item}</th>
                        })}
                    </tr>
                </thead>
                <tbody>
                    {bodyInfo?.map((row: Record<string, string>, rowIndex: number) => (
                        <tr key={rowIndex}>
                            {Object.values(row).map((cell: string, cellIndex: number) => (
                                <th key={cellIndex}>{cell}</th>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default SizeChartContent;